var map = {
	"./de/mecha-btn.png": "0ioW",
	"./en/mecha-btn.png": "Za15",
	"./es/mecha-btn.png": "fr5I",
	"./fr/mecha-btn.png": "g6bk",
	"./ja/mecha-btn.png": "s2Zd",
	"./ko/mecha-btn.png": "Nb/d",
	"./pt/mecha-btn.png": "/Fnq",
	"./ru/mecha-btn.png": "SBQf",
	"./tc/mecha-btn.png": "pFYt",
	"./th/mecha-btn.png": "iv8i"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8Rh2";